import { render, staticRenderFns } from "./updateDeliverInfo.vue?vue&type=template&id=1f6e4802&"
import script from "./updateDeliverInfo.vue?vue&type=script&lang=js&"
export * from "./updateDeliverInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports